function initDropdownObserver(dropdownSelector, stickyHeaderSelector, stickyWrapSelector) {
    function updateOverlapClass(isExpanded) {
        const $stickyHeader = $(stickyHeaderSelector);
        const $stickyWrap = $(stickyWrapSelector);

        if ($stickyHeader.length) {
            if (isExpanded) {
                $stickyHeader.addClass('overlap');
            } else {
                $stickyHeader.removeClass('overlap');
            }
        }

        if ($stickyWrap.length) {
            if (isExpanded) {
                $stickyWrap.addClass('overlap');
                return;
            }
            
            $stickyWrap.removeClass('overlap');
        }
    }

    function observeDropdown(dropdown) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
                    const isExpanded = dropdown.getAttribute('aria-expanded') === 'true';
                    updateOverlapClass(isExpanded);
                }
            });
        });

        observer.observe(dropdown, {
            attributes: true,
            attributeFilter: ['aria-expanded']
        });

        const initialIsExpanded = dropdown.getAttribute('aria-expanded') === 'true';
        updateOverlapClass(initialIsExpanded);
    }

    function findAndObserveDropdowns() {
        const dropdowns = document.querySelectorAll(dropdownSelector);
        if (dropdowns.length > 0) {
            dropdowns.forEach(observeDropdown);
        } else {
            setTimeout(findAndObserveDropdowns, 500);
        }
    }

    findAndObserveDropdowns();
}

export { initDropdownObserver };